import Vue from "vue";
import VueRadioToggleButtons from 'vue-radio-toggle-buttons';

import App from "./App.vue";
import router from "./router";

import 'vue-radio-toggle-buttons/dist/vue-radio-toggle-buttons.css';

Vue.use(VueRadioToggleButtons, {
  color: '#333',
  textColor: '#333',
  selectedTextColor: '#eee'
});
Vue.config.productionTip = false;

import "@/assets/main.css";

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
